<template>
  <div v-if="empty && !loading" class="diets-empty">
    <BaseIcon type="info" name="info" />
    <span>
      Nie masz dostępu do diet systemowych. Wykup wyższy pakiet programu, żeby aktywować dostęp.
    </span>
  </div>
  <div v-if="loading" class="list-loader">
    <div class="list-loader-bar"><div class="list-loader-bar__progress" /></div>
  </div>
</template>

<script setup lang="ts">
  import BaseIcon from '@/components/BaseIcon.vue'

  defineProps<{ empty: boolean; loading: boolean }>()
</script>
